export default "__VITE_ASSET__DMe7mFYl__"